import { gql } from '@apollo/client'
import React from 'react'

import { placesClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const usePlaceLevelState = () => React.useContext(Context)
export const usePlaceLevel = () => usePlaceLevelState()?.placeLevel

const QUERY = gql`
  query PlaceLevel($id: ID) {
    placeLevel(id: $id, filter: { includeDeleted: true }) {
      id
      name
      type
    }
  }
`

const PlaceLevelLoader = ({ children }) => {
  const { id } = useModalData() || {}

  const { data, ...state } = useQuery(QUERY, {
    skip: !id,
    variables: { id },
    client: placesClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default PlaceLevelLoader
